<!--
    校区管理-代理商列表-关联校区
    作用：选择需要管理的校区数据
-->
<template>
  <div class="relevanceCampus">
    <div class="name">代理商：{{ name }}</div>
    <AppList
      ref="list"
      :list.sync="list"
      title=""
      create-label="选择校区"
      @create="choiceCampus"
      :api="`/api/service/operate/agent/relation/clients/${this.id}`">
      <template slot-scope="props">
        <el-table :data="props.listData">
          <el-table-column
            v-for="column in columns"
            v-if="!column.show"
            :key="column.prop"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            :formatter="column.formatter"
          />
          <el-table-column
            label="操作"
            width="230px"
            class="orgin-btn"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                @click="unrelevance(scope.row)"
              >取消关联</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </AppList>
    <el-dialog
      title="关联校区"
      class="campus_list"
      :visible.sync="dialogVisible"
      width="1000px">
      <el-table
        class="campus_list_table"
        :data="campus_list"
        height="50vh"
        @selection-change="handleSelectionChange">
        <el-table-column
          fixed
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          v-for="column in campus_columns"
          v-if="!column.show"
          :key="column.prop"
          :prop="column.prop"
          :label="column.label"
          :width="column.width"
          :formatter="column.formatter"
        />
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="relevanceCampus">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "RelevanceCampus",
    inject: ['reload'],
    data() {
      return {
        id: this.$route.params.id,
        name: this.$route.params.name,
        list: {},
        campus_list: [],
        columns: [
          { prop: 'clients.review_used.name', label: '校区名称' },
          {
            label: '类型',
            formatter: row => row.school_is_master === 1 ? '总校' : '分校'
          },
          { prop: 'clients.master_info.name', label: '所属主体' },
          { prop: 'clients.review_used.user_name', label: '校长' },
          { prop: 'clients.review_used.user_mobile', label: '电话' }
        ],
        campus_columns: [
          { prop: 'review_used.name', label: '校区名称' },
          {
            label: '类型',
            formatter: row => row.school_is_master === 1 ? '总校' : '分校'
          },
          { prop: 'master_info.name', label: '所属主体' },
          { prop: 'review_used.user_name', label: '校长' },
          { prop: 'review_used.user_mobile', label: '电话' }
        ],
        isCreated: true,
        dialogVisible: false,
        selectionCampus: []
      }
    },
    methods: {
      // 选择校区
      choiceCampus() {
        this.dialogVisible = true;
        this.$http
          .get(`/api/service/operate/agent/optional/clients/${this.id}?page=1&per_page=9999`)
          .then((res) => {
            this.campus_list = res.items;
          })
          .catch((err) => {
            this.isCreated = true;
            this.$message.error(err.message);
          })
      },
      // 勾选校区
      handleSelectionChange(val) {
        console.log(val)
        this.selectionCampus = val.map(item => item.id);
      },
      // 取消关联
      unrelevance(row) {
        this.$confirm('是否要取消关联?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http
            .delete(`/api/service/operate/agent/relation/clients/${this.id}/${row.clients_id}`)
            .then(() => {
              this.$message.success('取消关联成功！')
              this.reload();
            })
            .catch((err) => {
              this.$message.error(err.message);
            });
        })
      },
      // 关联校区
      relevanceCampus() {
        if (this.isCreated) {
          this.isCreated = false;
          const data = {
            clients_ids: this.selectionCampus
          }
          this.$http
            .post(`/api/service/operate/agent/relation/clients/${this.id}`, data)
            .then((res) => {
              this.$message.success('关联校区成功！');
              this.dialogVisible = false;
              this.isCreated = true;
              this.reload();
              console.log(res)
            })
            .catch((err) => {
              this.isCreated = true;
              this.$message.error(err.message);
            })
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .relevanceCampus {
    position: relative;
    .name {
      position: absolute;
      font-size: 14px;
      color: #606266;
    }
    #posterHtml {
      position: fixed;
      left: -9999999px;
      top: 0;
    }
    .campus_list {
      /deep/
      .list-header {
        display: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/CampusManagement/factor/relevanceCampus.vue